import { Crown, ShieldCheck, Ticket, Briefcase } from 'lucide-react';

export const teamGhostRows = [
  {
    id: 't1',
    isSample: true,
    name: 'Rahul Sharma',
    email: 'rahul.ops@travels.com',
    role: 'OPERATIONS',
    phone: '+91 98200 11223',
    status: 'Active'
  },
  {
    id: 't2',
    opacity: 'opacity-45',
    name: 'Priya Patel',
    email: 'priya.trips@travels.com',
    role: 'BOOKINGS',
    phone: '+91 98211 44556',
    status: 'Active'
  },
  {
    id: 't3',
    opacity: 'opacity-30',
    name: 'Amit Verma',
    email: 'amit.v@travels.com',
    role: 'SUB-ADMIN',
    phone: '+91 98222 77889',
    status: 'Active'
  },
  {
    id: 't4',
    opacity: 'opacity-15',
    name: 'Neha Deshmukh',
    email: 'neha.tours@travels.com',
    role: 'OPERATIONS',
    phone: '+91 98233 99001',
    status: 'Active'
  }
];

export const teamColumns = [
  { label: 'Sr No.', span: 'col-span-1' },
  { label: 'Team Member', span: 'col-span-4' },
  { label: 'Role', span: 'col-span-2' },
  { label: 'Phone Number', span: 'col-span-3' },
  { label: 'Status', span: 'col-span-1', align: 'center' },
  { label: 'Actions', span: 'col-span-1', align: 'right' }
];

export const allRoleConfigs = [
  {
    value: 'admin',
    title: 'Admin',
    badge: 'Full Access',
    description: 'Complete access to dashboard, vouchers, app bookings, wallet payouts & team management.',
    icon: Crown,
    color: 'text-purple-600 bg-purple-50 border-purple-200'
  },
  {
    value: 'subadmin',
    title: 'Sub-Admin',
    badge: 'High Access',
    description: 'Access to vouchers, bookings, and adding/managing operational staff.',
    icon: ShieldCheck,
    color: 'text-indigo-600 bg-indigo-50 border-indigo-200'
  },
  {
    value: 'bookings',
    title: 'Bookings Team',
    badge: 'Operations',
    description: 'Access to generate and manage itinerary vouchers and bookings.',
    icon: Ticket,
    color: 'text-sky-600 bg-sky-50 border-sky-200'
  },
  {
    value: 'operations',
    title: 'Operations Team',
    badge: 'Operations',
    description: 'Access to operational itineraries, vouchers, and ground logistics.',
    icon: Briefcase,
    color: 'text-amber-600 bg-amber-50 border-amber-200'
  }
];

export const formatRoleName = (role) => {
  if (!role) return '';
  if (role === 'subadmin') return 'SUB-ADMIN';
  return role.toUpperCase();
};
